import { useMyNotificationBadges } from '@/features/authentication/_hooks/notification';
import { useOnChangeLocation } from '@/hooks';
import { z } from 'zod';

const notificationBadgeType = z.enum(['comment', 'workflow']);

type NotificationBadgeType = z.infer<typeof notificationBadgeType>;
type NotificationBadgeInfo = {
  isShow: boolean;
  count: number;
};

const REFETCH_INTERVAL_IN_MINUTES = 1;

export const useNotificationBadges = () => {
  const notificationBadges = useMyNotificationBadges({
    refetchIntervalInMinutes: REFETCH_INTERVAL_IN_MINUTES,
  });

  useOnChangeLocation(() => {
    notificationBadges.refetch();
  });

  return {
    comment: {
      isShow: !!notificationBadges.data?.comment.unread,
      count: notificationBadges.data?.comment.unread ?? 0,
    },
    workflow: {
      isShow: !!notificationBadges.data?.workflow.actionRequired,
      count: notificationBadges.data?.workflow.actionRequired ?? 0,
    },
  } satisfies Record<NotificationBadgeType, NotificationBadgeInfo>;
};
